import React from "react";
import {
    Box,
    Container,
    Typography,
    Paper,
    Alert,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EmailIcon from "@mui/icons-material/Email";

const RegistrationSuccess = () => {


    return (
        <Box
            sx={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 1,
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={6}
                    sx={{
                        borderRadius: 2,
                        overflow: "hidden",
                        background: "white",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            background: "linear-gradient(90deg, #b7dbe8 0%, #145a73 100%)",
                            textAlign: "center",
                            color: "white",
                            p: 3,
                        }}
                    >
                        <CheckCircleOutlineIcon
                            sx={{
                                fontSize: 60,
                                mb: 1,
                                backgroundColor: "white",
                                borderRadius: "50%",
                                padding: 1,
                                color: "#4caf50",
                            }}
                        />
                        <Typography variant="h4" fontWeight="bold">
                            Registration Successful!
                        </Typography>
                        <Typography variant="subtitle1" sx={{ mt: 0.5, opacity: 0.9 }}>
                            Account created successfully
                        </Typography>
                    </Box>

                    <Box sx={{ p: 3 }}>
                        {/* Main Message */}
                        <Box textAlign="center" mb={3}>
                            <Typography variant="h6" fontWeight="600" color="text.primary" sx={{ mb: 2 }}>
                                Check Your Email
                            </Typography>

                            <Alert
                                severity="info"
                                icon={<EmailIcon />}
                                sx={{
                                    mb: 2,
                                    textAlign: "left",
                                }}
                            >
                                Confirmation email sent to your registered email address.
                            </Alert>
                        </Box>

                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 1.5 }}>
                                Next Steps:
                            </Typography>

                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.9rem', pl: 2 }}>
                                <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: '20px' }}>
                                    <li style={{ marginBottom: '8px' }}>
                                        <strong>Check your inbox</strong> for the confirmation email
                                    </li>
                                    <li style={{ marginBottom: '8px' }}>
                                        <strong>Click the confirmation link</strong> to verify your email
                                    </li>
                                    <li>
                                        <strong>Set your password</strong> to complete account setup
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        {/* Quick Tip */}
                        <Paper
                            sx={{
                                p: 1.5,
                                borderRadius: 1.5,
                                backgroundColor: "#e8f5e9",
                                border: "1px solid #c8e6c9",
                                mb: 2,
                            }}
                        >
                            <Typography variant="body2" fontWeight="bold" color="#2e7d32" sx={{ mb: 0.5 }}>
                                💡 Quick Tip:
                            </Typography>
                            <Typography variant="body2" color="#2e7d32" sx={{ fontSize: '0.85rem' }}>
                                Check spam folder if email not received. Link valid for 24 hours.
                            </Typography>
                        </Paper>

                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default RegistrationSuccess;